const KEY_PREFIX = 'las.';

function set(key: string, value: string): void {
  localStorage.setItem(KEY_PREFIX + key, value);
}

function get(key: string): string | null {
  return localStorage.getItem(KEY_PREFIX + key);
}

function remove(key: string): void {
  localStorage.removeItem(KEY_PREFIX + key);
}

function clear(): void {
  localStorage.clear();
}

export default { set, get, remove, clear };
